import React from "react";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

import PlayCircleOutline from "@mui/icons-material/PlayCircleOutline";
import BarChartRounded from "@mui/icons-material/BarChartRounded";
import AccountBalanceOutlined from "@mui/icons-material/AccountBalanceOutlined";

import { styled, Typography } from '@mui/material';

const PREFIX = 'SmartIcon';

const classes = {
    smartIcon: `${PREFIX}-smartIcon`,
    title: `${PREFIX}-title`
};

const StyledLink = styled(Link)((
    {
        theme
    }
) => ({
    [`&.${classes.smartIcon}`]: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		height: "100%",
		background: "transparent",
		color: "#fff",
		textDecoration: "none",
		fontSize: "40px",
	},

    [`& .${classes.title}`]: {textAlign: "center", width: "80%"}
}));

export default function SmartIcon({configuration}) {


	const {t} = useTranslation();

	const icoSrc = configuration?.element?.icon?.type !== undefined ? configuration.element.icon.type : '';
	const icoTitle = configuration?.element?.icon?.title !== undefined ? configuration.element.icon.title : null;
	const icoLink = configuration?.element?.iconLink?.link !== undefined ? configuration.element.iconLink.link : '/';

	// TODO: Make this dynamic
	const setCurrentIcon = () => {
		switch (icoSrc) {
			case "barchart":
				return (
					<BarChartRounded fontSize="inherit" style={{marginBottom: "4px"}}/>
				);
			case "playcircle":
				return (
					<PlayCircleOutline fontSize="inherit" style={{marginBottom: "4px"}}/>
				);
			case "accountbalance":
				return (
					<AccountBalanceOutlined fontSize="inherit" style={{marginBottom: "4px"}}/>
				);
			default:
				return <></>;
		}
	};

	return (
        <StyledLink className={classes.smartIcon} to={icoLink}>
			{setCurrentIcon()}
			{icoTitle &&
			<Typography variant="caption" className={classes.title}>
				{t(icoTitle)}
			</Typography>
			}
		</StyledLink>
    );
}
